import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SystemHeader from '../SystemHeader';
import { LieuTrinhAPI } from '../../services/feature-api';
import { useFeatureConfig } from '../../contexts/FeatureConfigContext';
import { cdnThumb } from '../../utils/CdnImage';
import { markdownToHtml } from '../../utils/markdownToHtml';

// 17 Kiến thức sản phẩm — ô vẫn "Đang triển khai" trên màn hình chính; vào trang phải gõ mật khẩu (admin đặt ở
// Cấu hình tính năng → cột Mật khẩu xem thử). Tab Liệu trình = bảng lieu_trinh (admin soạn, kể cả nháp);
// tab Sản phẩm = bảng products. Mật khẩu giữ trong sessionStorage, mọi lệnh gửi header x-mat-khau.
const KEY = 'kien-thuc-san-pham';
const KHO_MK = `mk:${KEY}`;
const Icon = ({ name, size = 16, className = '', style }) => <span className={`material-symbols-rounded ${className}`} style={{ fontSize: size, lineHeight: 1, ...style }}>{name}</span>;
const XANH = '#1E5A35';
const fmtGia = (v) => (v ? `${Number(v).toLocaleString('vi-VN')} đ` : '');
const laUrl = (v) => /^https?:\/\//.test(String(v || ''));

// [[sp:195]] trong markdown → thẻ sản phẩm có ảnh (admin xem trước cùng công thức ở PE_Admin/LieuTrinhManagement)
export const chenSanPham = (html, dsSp) => html.replace(/\[\[sp:(\d+)\]\]/g, (_, id) => {
  const p = dsSp.find((x) => String(x.id) === id);
  if (!p) return `<span style="color:#b91c1c">[sản phẩm #${id} không có]</span>`;
  return `<span style="display:inline-flex;align-items:center;gap:5px;padding:2px 8px 2px 3px;margin:1px 2px;border:1px solid #C9E3D2;background:#F0F7F2;border-radius:999px;font-weight:600;color:${XANH};font-size:12.5px;vertical-align:middle;white-space:nowrap">${p.anh ? `<img src="${cdnThumb(p.anh)}" alt="" style="width:22px;height:22px;border-radius:999px;object-fit:cover;border:0;margin:0" />` : ''}${p.ten}</span>`;
});

const ThanhTab = ({ tab, setTab, so }) => (
  <div className="grid grid-cols-2 gap-1 p-1 bg-white rounded-xl border border-black/[.07]">
    {[['lieu-trinh', 'route', 'Liệu trình'], ['san-pham', 'spa', 'Sản phẩm']].map(([k, icon, ten]) => (
      <button key={k} type="button" onClick={() => setTab(k)} className={`h-9 rounded-lg text-[13px] font-semibold flex items-center justify-center gap-1 ${tab === k ? 'text-white' : 'text-gray-600'}`} style={tab === k ? { background: XANH } : {}}>
        <Icon name={icon} size={17} />{ten}{so[k] != null && <span className={`text-[11px] ${tab === k ? 'text-white/70' : 'text-gray-400'}`}>({so[k]})</span>}
      </button>
    ))}
  </div>
);

const KhoiNho = ({ ten, children }) => (
  <section className="bg-white rounded-xl border border-black/[.07] overflow-hidden">
    <div className="px-3 h-9 flex items-center border-b border-black/[.06] bg-[#F0F7F2]"><h3 className="text-[11.5px] font-bold uppercase tracking-[.1em]" style={{ color: XANH }}>{ten}</h3></div>
    <div className="px-3 py-2.5">{children}</div>
  </section>
);

// ── Tab 1: Liệu trình ──
const LieuTrinhChiTiet = ({ l, dsSp, onVe }) => (
  <div className="space-y-3">
    <button type="button" onClick={onVe} className="text-[12.5px] font-semibold flex items-center gap-1 text-gray-600"><Icon name="arrow_back" size={17} />Tất cả liệu trình</button>
    <div className="bg-white rounded-xl border border-black/[.07] p-3">
      <div className="flex items-start gap-2">
        <h2 className="text-[17px] font-bold leading-tight flex-1">{l.ten}</h2>
        <span className={`shrink-0 text-[10.5px] font-semibold rounded-full px-2 py-0.5 ${l.hien ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-800'}`}>{l.hien ? 'Đang hiện' : 'Nháp'}</span>
      </div>
      <div className="flex flex-wrap gap-1 mt-2">
        {(l.van_de || []).map((v) => <span key={v} className="text-[11.5px] font-medium rounded-full px-2 py-0.5 bg-[#F0F7F2]" style={{ color: XANH }}>#{v}</span>)}
        {l.so_ngay && <span className="text-[11.5px] font-medium rounded-full px-2 py-0.5 bg-gray-100 text-gray-700">{l.so_ngay} ngày</span>}
      </div>
      {l.mo_ta && <p className="text-[13px] text-gray-700 leading-relaxed mt-2">{l.mo_ta}</p>}
    </div>
    <KhoiNho ten={`Sản phẩm theo thứ tự dùng · ${l.san_pham.length}`}>
      <ol className="divide-y divide-gray-100">
        {l.san_pham.map((s) => (
          <li key={s.id + '-' + s.thu_tu} className="flex items-center gap-2.5 py-2 first:pt-0 last:pb-0">
            <span className="w-5 h-5 rounded-full text-white text-[11px] font-bold flex items-center justify-center shrink-0" style={{ background: XANH }}>{s.thu_tu}</span>
            {s.anh ? <img src={cdnThumb(s.anh)} alt="" className="w-11 h-11 rounded-lg object-cover bg-gray-100 shrink-0" /> : <span className="w-11 h-11 rounded-lg bg-gray-100 shrink-0" />}
            <span className="flex-1 min-w-0">
              <span className="block text-[13.5px] font-semibold leading-tight">{s.ten} <span className="text-gray-500 font-medium">× {Number(s.so_luong)} {s.don_vi || ''}</span></span>
              {s.cach_dung && <span className="block text-[12px] text-gray-500 leading-snug mt-0.5">{s.cach_dung}</span>}
            </span>
          </li>
        ))}
      </ol>
    </KhoiNho>
    {l.huong_dan && (
      <KhoiNho ten="Hướng dẫn sử dụng">
        <div className="markdown-content text-[13.5px] text-gray-800 leading-relaxed" dangerouslySetInnerHTML={{ __html: chenSanPham(markdownToHtml(l.huong_dan), dsSp) }} />
      </KhoiNho>
    )}
  </div>
);

const TabLieuTrinh = ({ ds, dsSp }) => {
  const [chon, setChon] = useState(null);
  if (chon) return <LieuTrinhChiTiet l={chon} dsSp={dsSp} onVe={() => setChon(null)} />;
  if (!ds.length) return <p className="text-center text-gray-500 text-[13px] py-10">Admin chưa soạn liệu trình nào.</p>;
  return (
    <div className="space-y-2.5">
      {ds.map((l) => (
        <button key={l.id} type="button" onClick={() => { setChon(l); window.scrollTo(0, 0); }} className="w-full text-left bg-white rounded-xl border border-black/[.07] p-3 active:opacity-80">
          <div className="flex items-start gap-2">
            <h3 className="text-[14.5px] font-bold leading-tight flex-1">{l.ten}</h3>
            <span className={`shrink-0 text-[10.5px] font-semibold rounded-full px-2 py-0.5 ${l.hien ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-800'}`}>{l.hien ? 'Đang hiện' : 'Nháp'}</span>
          </div>
          <p className="text-[11.5px] text-gray-500 mt-1">{(l.van_de || []).map((v) => `#${v}`).join(' ')}{l.so_ngay && ` · ${l.so_ngay} ngày`} · {l.san_pham.length} sản phẩm{l.so_feedback > 0 && ` · ${l.so_feedback} feedback`}</p>
          <div className="flex items-center gap-1 mt-2 overflow-hidden">
            {l.san_pham.slice(0, 6).map((s, i) => (
              <React.Fragment key={s.id + '-' + s.thu_tu}>
                {i > 0 && <Icon name="chevron_right" size={14} className="text-gray-300 shrink-0" />}
                {s.anh ? <img src={cdnThumb(s.anh)} alt={s.ten} title={s.ten} className="w-9 h-9 rounded-lg object-cover bg-gray-100 shrink-0" /> : <span className="w-9 h-9 rounded-lg bg-gray-100 shrink-0" />}
              </React.Fragment>
            ))}
            {l.san_pham.length > 6 && <span className="text-[11px] text-gray-400 ml-1">+{l.san_pham.length - 6}</span>}
          </div>
        </button>
      ))}
    </div>
  );
};

// ── Tab 2: Sản phẩm (bảng products) ──
const SanPhamChiTiet = ({ p, onVe }) => (
  <div className="space-y-3">
    <button type="button" onClick={onVe} className="text-[12.5px] font-semibold flex items-center gap-1 text-gray-600"><Icon name="arrow_back" size={17} />Tất cả sản phẩm</button>
    <div className="bg-white rounded-xl border border-black/[.07] overflow-hidden">
      {p.anh && <img src={p.anh} alt="" className="w-full max-h-[320px] object-contain bg-gray-50" />}
      <div className="p-3">
        <h2 className="text-[17px] font-bold leading-tight">{p.ten}</h2>
        <p className="text-[12px] text-gray-500 mt-0.5">{p.ten_day_du}</p>
        {p.gia && <p className="text-[15px] font-bold mt-1.5" style={{ color: XANH }}>{fmtGia(p.gia)}</p>}
      </div>
    </div>
    {[['Mô tả', p.mo_ta], ['Thành phần', p.thanh_phan], ['Đối tượng', p.doi_tuong], ['Khi nào dùng', p.khi_nao_dung], ['Độ tuổi', p.do_tuoi], ['Loại', p.loai], ['Kiểu da', p.kieu_da]]
      .filter(([, v]) => v).map(([ten, v]) => (
        <KhoiNho key={ten} ten={ten}><p className="text-[13.5px] text-gray-800 leading-relaxed whitespace-pre-line">{v}</p></KhoiNho>
      ))}
    {p.huong_dan && (
      <KhoiNho ten="Hướng dẫn sử dụng">
        {laUrl(p.huong_dan)
          ? <a href={p.huong_dan} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[13.5px] font-semibold underline" style={{ color: XANH }}><Icon name="open_in_new" size={16} />Mở tài liệu hướng dẫn</a>
          : <p className="text-[13.5px] text-gray-800 leading-relaxed whitespace-pre-line">{p.huong_dan}</p>}
      </KhoiNho>
    )}
  </div>
);

const TabSanPham = ({ ds }) => {
  const [q, setQ] = useState('');
  const [chon, setChon] = useState(null);
  const hien = useMemo(() => { const k = q.trim().toLowerCase(); return ds.filter((p) => !k || `${p.ten} ${p.ten_day_du}`.toLowerCase().includes(k)); }, [ds, q]);
  if (chon) return <SanPhamChiTiet p={chon} onVe={() => setChon(null)} />;
  return (
    <div>
      <div className="flex items-center gap-1.5 bg-white border border-gray-200 rounded-lg px-2.5 mb-2.5">
        <Icon name="search" size={17} className="text-gray-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tìm sản phẩm…" className="flex-1 py-2 text-[14px] outline-none bg-transparent" />
      </div>
      <div className="grid grid-cols-3 gap-2">
        {hien.map((p) => (
          <button key={p.id} type="button" onClick={() => { setChon(p); window.scrollTo(0, 0); }} className="bg-white rounded-xl border border-black/[.07] overflow-hidden text-left active:opacity-80">
            {p.anh ? <img src={cdnThumb(p.anh)} alt="" className="w-full aspect-square object-cover bg-gray-50" loading="lazy" /> : <div className="w-full aspect-square bg-gray-100" />}
            <p className="text-[12px] font-semibold leading-tight px-1.5 pt-1.5 pb-2 line-clamp-2 min-h-[2.4em]">{p.ten}</p>
          </button>
        ))}
      </div>
      {!hien.length && <p className="text-center text-gray-500 text-[13px] py-10">Không có sản phẩm khớp.</p>}
    </div>
  );
};

// ── Trang ──
const KienThucSanPhamPage = ({ userInfo, onLogout, totalPoints, accessToken, onRefreshPoints }) => {
  const navigate = useNavigate();
  const { features } = useFeatureConfig();
  const canMk = features.find((f) => f.featureKey === KEY)?.coMatKhau !== false; // chưa tải config → cứ hỏi, API quyết
  const [mk, setMk] = useState(() => sessionStorage.getItem(KHO_MK) || '');
  const [nhap, setNhap] = useState('');
  const [loi, setLoi] = useState('');
  const [dangMo, setDangMo] = useState(false);
  const [tab, setTab] = useState('lieu-trinh');
  const [lt, setLt] = useState(null);
  const [sp, setSp] = useState(null);
  const daMo = !canMk || !!mk;

  useEffect(() => {
    if (!accessToken || !daMo) return;
    Promise.all([LieuTrinhAPI.list(accessToken, mk), LieuTrinhAPI.sanPham(accessToken, mk)]).then(([a, b]) => {
      if (!a.success || !b.success) { sessionStorage.removeItem(KHO_MK); setMk(''); setLoi('Mật khẩu không còn đúng, gõ lại.'); return; }
      setLt(a.data || []); setSp(b.data || []);
    });
  }, [accessToken, daMo, mk]);

  const moKhoa = async (e) => {
    e.preventDefault();
    setDangMo(true); setLoi('');
    const r = await LieuTrinhAPI.moKhoa(accessToken, nhap.trim());
    setDangMo(false);
    if (r.success) { sessionStorage.setItem(KHO_MK, nhap.trim()); setMk(nhap.trim()); } else setLoi('Sai mật khẩu');
  };

  return (
    <div className="min-h-screen bg-[#EEEDEA] font-['Inter'] text-gray-900">
      <SystemHeader userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} pageTitle="Kiến thức sản phẩm" onRefreshPoints={onRefreshPoints} />
      <div className="px-3 py-3 max-w-[720px] mx-auto space-y-3">
        <div className="flex items-center gap-2">
          <button type="button" onClick={() => navigate('/dashboard')} aria-label="Quay lại" className="w-8 h-8 rounded-full bg-white border border-black/[.07] flex items-center justify-center"><Icon name="arrow_back" size={18} /></button>
          <h1 className="text-[16px] font-bold flex-1">17 · Kiến thức sản phẩm</h1>
          <span className="text-[10.5px] font-bold text-amber-800 bg-amber-100 rounded-full px-2 py-0.5">Đang triển khai</span>
        </div>

        {!daMo ? (
          <form onSubmit={moKhoa} className="bg-white rounded-xl border border-black/[.07] p-4 max-w-[360px] mx-auto text-center">
            <span className="w-12 h-12 rounded-full bg-amber-50 text-amber-600 inline-flex items-center justify-center"><Icon name="lock" size={26} /></span>
            <p className="text-[14px] font-semibold mt-2">Mục này đang xây, chỉ mở cho người có mật khẩu</p>
            <input type="password" inputMode="numeric" autoComplete="off" value={nhap} onChange={(e) => setNhap(e.target.value)} placeholder="Mật khẩu xem thử"
                   className="mt-3 w-full text-center text-[16px] tracking-[.3em] border border-gray-300 rounded-lg px-3 py-2.5 outline-none focus:border-[#1E5A35]" />
            {loi && <p className="text-[12px] text-red-600 mt-1.5">{loi}</p>}
            <button type="submit" disabled={dangMo || !nhap.trim()} className="mt-3 w-full py-2.5 rounded-lg text-white font-semibold text-[14px] disabled:opacity-40" style={{ background: XANH }}>{dangMo ? 'Đang mở…' : 'Mở'}</button>
            <button type="button" onClick={() => navigate('/dashboard')} className="mt-2 text-[12.5px] text-gray-500">Về màn hình chính</button>
          </form>
        ) : !lt || !sp ? <p className="text-center text-gray-400 text-[13px] py-10">{loi || 'Đang tải…'}</p> : (
          <>
            <ThanhTab tab={tab} setTab={setTab} so={{ 'lieu-trinh': lt.length, 'san-pham': sp.length }} />
            {tab === 'lieu-trinh' ? <TabLieuTrinh ds={lt} dsSp={sp} /> : <TabSanPham ds={sp} />}
          </>
        )}
      </div>
    </div>
  );
};

export default KienThucSanPhamPage;
